<script lang="ts">
	import ReadMore from 'components/ReadMore/ReadMore.svelte';
	import { htmlRegex } from 'utils/regex/html';

	export let dark = false;

	let className: string;
	export { className as class };

	export let keyTerms: {
		title: string;
		url?: string;
		slug: {
			current: string;
		};
		description: string;
	}[];
</script>

<section class={`key-terms container ${className || ''}`} class:dark>
	<div class="tablet-wrapper">
		<div class="scroll-wrapper">
			<ul class="terms-list">
				{#each keyTerms as term}
					<li class="term">
						<p class="term-title">
							{`${term.title.replace(htmlRegex, '').substring(0, 60)}${
								term.title.length > 60 ? '...' : ''
							}`}
						</p>
						<div class="content-wrapper">
							<p class="term-content">
								{`${term.description.replace(htmlRegex, '').substring(0, 150)}${
									term.description.length > 150 ? '...' : ''
								}`}
							</p>
							<ReadMore
								as="link"
								linkTo={term.slug ? `/learn/glossary/${term.slug.current}` : term.url}
								class="font-12"
								label={term.title}
							/>
						</div>
					</li>
				{/each}
			</ul>
		</div>
	</div>
</section>

<style lang="scss">
	@import 'keyTermsSection';
</style>
